import type { CourseId, DifficultyParams, Mode, Surface, ZoneId } from "../config/types";

export interface RunState {
    mode: Mode;
    course: CourseId | null;
    seed: number;
    phase: "ready" | "running" | "paused" | "ended";
    timeS: number;
    distanceM: number;
    speed: number;
    bestSpeed: number;
    boost: number;
    score: number;
    styleScore: number;
    combo: number;
    longestCombo: number;
    jumpTricks: number;
    tricksLanded: number;
    crashes: number;
    airtimeS: number;
    zonesReached: ZoneId[];
    escaped: boolean;
    gatesPassed: number;
    gatesMissed: number;
    penaltyS: number;
    bigfootActive: boolean;
    difficulty: DifficultyParams;
    zone: ZoneId;
    surface: Surface;
    gripBonus: number;
    progress: number;
}

export function createRunState(mode: Mode, course: CourseId | null, seed: number): RunState {
    return {
        mode,
        course,
        seed,
        phase: "ready",
        timeS: 0,
        distanceM: 0,
        speed: 0,
        bestSpeed: 0,
        boost: 1,
        score: 0,
        styleScore: 0,
        combo: 1,
        longestCombo: 1,
        jumpTricks: 0,
        tricksLanded: 0,
        crashes: 0,
        airtimeS: 0,
        zonesReached: [],
        escaped: false,
        gatesPassed: 0,
        gatesMissed: 0,
        penaltyS: 0,
        bigfootActive: false,
        difficulty: emptyDifficulty(),
        zone: "meadow",
        surface: "grass",
        gripBonus: 1,
        progress: 0,
    };
}

function emptyDifficulty(): DifficultyParams {
    return {
        treeDensity: 0, rockDensity: 0, dogDensity: 0, hikerDensity: 0, npcRiderDensity: 0, wildlifeDensity: 0,
        jumpFrequency: 0, regionFrequency: 0, gateFrequency: 0, pickupFrequency: 0, setPieceWeight: 0,
        bigfootAggression: 0, scale: 0,
    };
}
